module.exports = __webpack_public_path__ + "img/phone.4c3fcd38.svg";